module.exports = __webpack_public_path__ + "img/idcard_hold.0abd1ec8.png";